import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BackIcon, CloseIcon } from '../icons';
import { Container, Title } from './styles';

type PageHeaderProps = {
    id: string;
    title: String;
    showBackButton?: boolean;
    showCloseButton?: boolean;
    handleBackButton?: () => void;
    handleCloseButton?: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({
    id,
    title,
    showBackButton = false,
    showCloseButton = true,
    handleBackButton,
    handleCloseButton
}) => {
    const navigate = useNavigate();

    return (
        <Container>
            {showBackButton && (
                <BackIcon
                    id={`${id}.closebutton`}
                    onClick={() => {
                        if (handleBackButton) {
                            handleBackButton();
                        } else {
                            navigate(-1);
                        }
                    }}
                />
            )}
            <Title>
                {title}
            </Title>
            {showCloseButton ? (
                <CloseIcon
                    id={`${id}.closebutton`}
                    onClick={() => {
                        if (handleCloseButton) {
                            handleCloseButton();
                        } else {
                            navigate(-1);
                        }
                    }}
                />
            ) : (
                <div />
            )}
        </Container>
    );
};

export { PageHeader };
export type { PageHeaderProps };
